import { isFrontendSentryEnabled } from "@atoms/sentry-module/frontend";
import { translate } from "../i18n/TranslationBackendRegistry";
import type { NotifyOptions } from "./notifier";

export type SentryFeedbackSource =
  | "graphql-error-toast"
  | "error-boundary"
  | "manual";

export type SentryFeedbackRequest = Readonly<{
  associatedEventId?: string;
  associatedException?: unknown;
  source: SentryFeedbackSource;
  title?: string;
}>;

export type SentryFeedbackReporter = (request: SentryFeedbackRequest) => void;

let globalSentryFeedbackReporter: SentryFeedbackReporter | null = null;

export function setGlobalSentryFeedbackReporter(
  reporter: SentryFeedbackReporter | null,
): void {
  globalSentryFeedbackReporter = reporter;
}

export function canOpenSentryFeedbackDialog(): boolean {
  return isFrontendSentryEnabled() && globalSentryFeedbackReporter !== null;
}

export function openGlobalSentryFeedbackDialog(
  request: SentryFeedbackRequest,
): void {
  if (!canOpenSentryFeedbackDialog()) return;
  globalSentryFeedbackReporter?.(request);
}

export function makeSentryFeedbackNotifyAction(
  request: SentryFeedbackRequest,
): NotifyOptions["action"] | undefined {
  if (!request.associatedEventId || !canOpenSentryFeedbackDialog()) {
    return undefined;
  }

  return {
    label: translate("framework.error.feedback", "Feedback hinzufügen"),
    kind: "link",
    onClick: () => openGlobalSentryFeedbackDialog(request),
  };
}
